import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import {
  Alert,
  ButtonContainer,
  Card,
  Col,
  FormInput,
  FormInputText,
  FormInputCheckbox,
  Row
} from 'camino-react'

import WorkTypeFormBillingDetails from './BillingDetails'
import BillingDetailsFormDescription from './BillingDetailsFormDescription'

import FormSection from 'Components/FormSection'
import FormSectionDescription from 'Components/FormSectionDescription'
import { cloudhelpPut } from 'Utilities/CloudHelp'
import { csrfToken } from 'Utilities/Csrf'

class WorkTypeEditForm extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      workType: props.workType,
      billingDetails: props.billingDetails
    }
  }

  handleFieldValue = (key, value) => {
    this.setState((prevState) => {
      const { workType } = prevState

      const newFields = Object.assign({}, workType, { [key]: value })

      return { workType: newFields }
    })
  }

  handleBillingDetailFieldValue = (field, value, index) => {
    this.setState((prevState) => {
      const { billingDetails } = prevState

      billingDetails[index][field] = value

      return { billingDetails }
    })
  }

  addBillingDetails = () => {
    this.setState((prevState) => {
      const { billingDetails } = this.state
      const newBillingDetails = _.clone(billingDetails)
      newBillingDetails.push({
        region_id: null,
        minimum_time: 15,
        round_by: 15
      })

      return { billingDetails: newBillingDetails }
    })
  }

  submitForm = () => {
    const { paths: {
      updatePath,
      indexPath
    } } = this.props

    const {
      workType: { name, on_site },
      billingDetails
    } = this.state

    const patchData = {
      authenticity_token: csrfToken(),
      work_type: {
        name,
        on_site,
        billing_details_attributes: billingDetails
      }
    }

    cloudhelpPut(updatePath, patchData)
      .then((response) => {
        window.location.href = indexPath
      })
      .catch((error) => {
        const { response: { data } } = error

        this.setState({
          alert: {
            type: 'error',
            title: data.message,
            children: _.map(data.errors, msg => (
              <p>
                {msg}
              </p>
            ))
          }
        })
      })
  }

  render () {
    const {
      regions,
      paths: {
        index: indexPath
      }
    } = this.props

    const {
      alert,
      billingDetails,
      workType: {
        name,
        on_site
      }
    } = this.state

    const {
      addBillingDetails,
      handleFieldValue,
      handleBillingDetailFieldValue,
      submitForm
    } = this

    const regionOptions = _.map(regions, region => ({ label: region.name, value: region.id }))

    return (
      <Row>
        <Col>
          {alert && <Alert {...alert} />}
          <FormSection>
            <Row noGutters>
              <Col width={12}>
                <FormSectionDescription title="Details" text="" />
              </Col>

              <Col width={12}>
                <Card>
                  <div>
                    <FormInput label="Name">
                      <FormInputText
                        onValue={value => handleFieldValue('name', value)}
                        value={name}
                      />
                    </FormInput>
                    <FormInput label="On-Site">
                      <FormInputCheckbox
                        id="on-site-work-type"
                        // eslint-disable-next-line camelcase
                        value={on_site}
                        rows={5}
                        onValue={value => handleFieldValue('on_site', value)}
                      />
                    </FormInput>
                  </div>
                </Card>
              </Col>
            </Row>
          </FormSection>

          <FormSection>
            <Row noGutters>
              <Col width={12}>
                <FormSectionDescription title="Billing Details">
                  <BillingDetailsFormDescription />
                </FormSectionDescription>
              </Col>

              <Col width={12}>
                <Card padding="none">
                  {_.map(billingDetails, (billingDetail, index) => (
                    <WorkTypeFormBillingDetails
                      regionOptions={regionOptions}
                      handleBillingDetailFieldValue={handleBillingDetailFieldValue}
                      billingDetail={billingDetail}
                      index={index}
                    />
                  ))}
                  <div style={{ padding: '20px' }}>
                    <button type="button" className="link" onClick={() => (addBillingDetails())}>
                      + Add Billing Details
                    </button>
                  </div>
                </Card>
              </Col>
            </Row>
          </FormSection>
          <ButtonContainer>
            <Row classExtra="row--full-width">
              <Col classExtra="form-section">
                <div className="form-section__actions">
                  <a href={indexPath} className="button button--large button--secondary form-section__action">
                    Cancel
                  </a>
                  <button
                    type="button"
                    className="button button--large form-section__action"
                    onClick={submitForm}
                  >
                    Submit
                  </button>
                </div>
              </Col>
            </Row>
          </ButtonContainer>
        </Col>
      </Row>
    )
  }
}

WorkTypeEditForm.propTypes = {
  workType: PropTypes.shape({
    name: PropTypes.string
  }).isRequired,
  billingDetails: PropTypes.arrayOf(PropTypes.object),
  regions: PropTypes.arrayOf(PropTypes.object),
  paths: PropTypes.shape({
    index: PropTypes.string
  })
}

WorkTypeEditForm.defaultProps = {
  billingDetails: [],
  regions: [],
  paths: {
    index: '/'
  }
}

export default WorkTypeEditForm
